module.exports = __webpack_public_path__ + "img/icons BFr_2.e3bac923.svg";